import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
	CALL_TO_ACTION_TYPES,
	NOTE_TYPES,
	NoteComponent,
} from 'src/app/ui/note/note.component';
import { dispatch, select } from '@ngxs/store';
import { OverwriteFields } from 'src/app/shared/state/user-profile/actions';
import { UserProfileState } from 'src/app/shared/state/user-profile';

@Component({
	selector: 'app-e-signing-disclaimer',
	imports: [NoteComponent],
	templateUrl: './e-signing-disclaimer.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: { class: 'empty:hidden' },
})
export class ESigningDisclaimerComponent {
	private OverwriteFields = dispatch(OverwriteFields);
	public NOTE_CLOSE_TYPE = CALL_TO_ACTION_TYPES.CLOSE;
	public NOTE_INFO_TYPE = NOTE_TYPES.INFO;
	public hideSigningFieldNote_ = select(
		UserProfileState.isSigningFieldsExplanationNoteHidden,
	);
	public closeFieldNote(): void {
		this.OverwriteFields({
			field: 'settings.hideNotifications.hideSigningFieldsExplanationNote',
			value: true,
		});
	}
}
